import React, { Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextFieldWithValidation } from '../../material-ui-wrappers/with-validations';

const PasswordResetInputsComponent = ({
  classes,
  model,
  handleChange,
  hasSubmitted,
  validations
}) => (
  <Fragment>
    <TextFieldWithValidation
      id='userName'
      label='Email'
      name='userName'
      value={model.userName}
      onChange={handleChange}
      className={`${classes.textField}`}
      InputProps={{
        className: classes.input
      }}
      InputLabelProps={{
        className: classes.textField
      }}
      margin='normal'
      rules={validations['userName']}
      formSubmitted={hasSubmitted}
    />
  </Fragment>
);

const styles = theme => ({
  textField: {
    margin: theme.spacing.unit,
    display: 'flex'
  }
});

export const PasswordResetInputs = withStyles(styles)(
  PasswordResetInputsComponent
);
